import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './core/services/auth.service';
import { ChooseOrgComponent } from './components/choose-org/choose-org.component';
import { ErrorInterceptor } from './core/services/authentication/error.interceptor';
import { AlertService } from './core/services/alert.service';
import { CommonModule } from '@angular/common';

// DashboardComponent and BuilderComponent moved to LayoutModule (lazy-loaded)
// IntegratorModule - lazy-loaded via routes (room/share, ai-tutor/share, etc.)
// AppComponentsModule - imported in LayoutModule (loaded when authenticated)
// This reduces initial bundle by deferring heavy SharedModule (Quill, Stripe, etc.) until needed

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      //@ts-ignore
      authService.getUserByToken().subscribe().add(resolve);
    });
  };
}

@NgModule({
  declarations: [
    AppComponent,
    ChooseOrgComponent,
    // DashboardComponent and BuilderComponent now in LayoutModule for lazy-loading
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    ClipboardModule,
    CommonModule,
    // IntegratorModule and AppComponentsModule removed from here
    // Both are now loaded on-demand:
    // - IntegratorModule: lazy-loaded via routes (room/share, ai-tutor/share, etc.)
    // - AppComponentsModule: imported in LayoutModule (loaded after auth)
    // #fake-start#
    // environment.isMockEnabled
    //   ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
    //     passThruUnknownUrl: true,
    //     dataEncapsulation: false,
    //   })
    //   : [],
    // #fake-end#
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AlertService,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
